import React from "react";
import { ArrowRight } from "lucide-react";
import { Header } from "../components/site/Header";
import { Footer } from "../components/site/Footer";
import { usePageMeta } from "../components/site/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "Page Not Found | Home Pro Connect",
    description: "The page you're looking for doesn't exist. Find contractor connections for major projects and home services in the SC Lowcountry.",
  });
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 grid place-items-center px-6 pt-32 pb-20" data-testid="not-found">
        <div className="text-center max-w-lg">
          <p className="font-display text-7xl font-extrabold text-[#54BCE6]">404</p>
          <h1 className="mt-4 font-display text-3xl md:text-4xl font-bold text-[#133955]">This page doesn't exist</h1>
          <p className="mt-3 text-[#173042]/70">The link may be old or mistyped. Here's where to go instead:</p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="/" data-testid="nf-home" className="inline-flex items-center gap-2 rounded-full bg-[#133955] text-white px-6 py-3 font-bold hover:bg-[#54BCE6] hover:text-[#133955] transition-colors">Home <ArrowRight size={16} /></a>
            <a href="/sc/major-projects/" data-testid="nf-major" className="inline-flex items-center gap-2 rounded-full border-2 border-[#133955] text-[#133955] px-6 py-3 font-bold hover:bg-[#133955] hover:text-white transition-colors">Major Projects</a>
            <a href="/sc/home-services/" data-testid="nf-services" className="inline-flex items-center gap-2 rounded-full border-2 border-[#133955] text-[#133955] px-6 py-3 font-bold hover:bg-[#133955] hover:text-white transition-colors">Home Services</a>
          </div>
          <p className="mt-6 text-sm text-[#173042]/60">Looking for guides? <a href="/blog/" className="text-[#54BCE6] font-semibold hover:text-[#133955]">Visit our blog</a>.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
